import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie !");
      nav("/dashboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setBusy(false); }
  };

  const quickLogin = async (qEmail, qPassword) => {
    setBusy(true);
    try {
      await login(qEmail, qPassword);
      toast.success("Connexion réussie !");
      nav("/dashboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setBusy(false); }
  };

  const quickAccounts = [
    { key: "admin", label: "COCARDE PIZZA", email: "jbesson13800@gmail.com", password: "Cocarde2027!", cls: "bg-cc-navy hover:bg-[#12336b]" },
    { key: "pizzeria", label: "PIZZERIA", email: "mario@demo.fr", password: "demo123", cls: "bg-cc-blue hover:brightness-110" },
    { key: "client", label: "CLIENT", email: "client@demo.fr", password: "demo123", cls: "bg-cc-red hover:brightness-110" },
  ];

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-12 bg-slate-100">
      <div className="w-full max-w-md card-cocarde p-8">
        <div className="flex justify-center mb-6"><Logo /></div>
        <h1 className="font-display text-3xl cc-navy text-center">CONNEXION</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="eyebrow text-slate-500">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-1 border border-slate-300 rounded-xl px-4 py-3 focus:border-cc-red outline-none" placeholder="vous@email.fr" />
          </div>
          <div>
            <label className="eyebrow text-slate-500">Mot de passe</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-1 border border-slate-300 rounded-xl px-4 py-3 focus:border-cc-red outline-none" placeholder="••••••••" />
          </div>
          <button data-testid="login-submit" disabled={busy} className="btn-cocarde w-full disabled:opacity-60">
            {busy ? "Connexion…" : "Se connecter"}
          </button>
        </form>

        <div className="mt-6">
          <div className="flex items-center gap-3">
            <span className="h-px flex-1 bg-slate-200" />
            <span className="text-[11px] text-slate-400 font-mono uppercase tracking-wider">Accès rapide démo</span>
            <span className="h-px flex-1 bg-slate-200" />
          </div>
          <div className="grid grid-cols-3 gap-2 mt-4">
            {quickAccounts.map((a) => (
              <button key={a.key} type="button" data-testid={`quick-login-${a.key}`} disabled={busy}
                onClick={() => quickLogin(a.email, a.password)}
                className={`${a.cls} text-white text-[11px] font-bold uppercase tracking-wide rounded-xl py-3 px-1 leading-tight transition disabled:opacity-60`}>
                {a.label}
              </button>
            ))}
          </div>
        </div>

        <p className="text-center text-sm text-slate-500 mt-5">
          Pas encore de compte ? <Link to="/register" data-testid="go-register" className="text-cc-red font-bold">Créer un compte</Link>
        </p>
      </div>
    </div>
  );
}
